import React from "react";
import { JoseraFinal } from "../../../utils/Customer/products";
import VideoGridSection from "../../../components/customer/VideosGridSection";
import { Play, Sparkles, Flame, Eye } from "lucide-react";

const CustomerVideoScreen: React.FC = () => {
    const firstBatch = JoseraFinal.slice(0, 8);
    const secondBatch = JoseraFinal.slice(8);

    return (
        <div className="max-w-7xl px-4 mx-auto space-y-5 py-8 animate-in fade-in duration-500">

            {/* UPGRADED ENGAGING HEADER SECTION */}
            <div className="border-b border-gray-100 pb-6">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                    <div className="space-y-3 flex-1">
                        {/* Interactive Status Tag */}
                        <div className="inline-flex items-center gap-1.5 bg-gradient-to-r from-red-500 to-amber-500 text-white text-[11px] font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-sm">
                            <span className="w-1.5 h-1.5 rounded-full bg-white animate-ping" />
                            <span>Live Feed</span>
                        </div>

                        <div className="space-y-1">
                            <h1 className="text-3xl md:text-4xl font-black text-logoHeading tracking-tight flex items-center gap-3">
                                Watch. Love. Shop.
                                <span className="inline-flex items-center justify-center bg-amber-500/10 text-amber-600 p-2 rounded-2xl">
                                    <Play size={22} fill="currentColor" className="translate-x-[1px]" />
                                </span>
                            </h1>
                            <p className="text-sm md:text-base text-gray-500 font-medium max-w-2xl leading-relaxed">
                                Explore authentic pet moments! Tap any video card to watch your favorite furry companions test premium gear, treats, and toys in real-time.
                            </p>
                        </div>
                    </div>

                    {/* Social Hub Stats Cloud */}
                    <div className="flex items-center gap-3 self-start md:self-auto bg-gray-50 border border-gray-100 p-2.5 rounded-2xl shadow-inner">
                        <div className="bg-white px-4 py-2 rounded-xl shadow-sm border border-gray-50 text-center min-w-[90px]">
                            <span className="block text-lg font-black text-logoHeading">Active</span>
                            <span className="text-[10px] text-emerald-500 font-bold uppercase tracking-wider flex items-center justify-center gap-1">
                                <span className="w-1 h-1 rounded-full bg-emerald-500 animate-pulse" /> Online
                            </span>
                        </div>
                        <div className="bg-white px-4 py-2 rounded-xl shadow-sm border border-gray-50 text-center min-w-[90px]">
                            <span className="block text-lg font-black text-logoHeading">{JoseraFinal.length}+</span>
                            <span className="text-[10px] text-gray-400 font-bold uppercase tracking-wider flex items-center justify-center gap-1">
                                <Eye size={10} /> Clips
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* BATCH 1: FIRST 8 VIDEOS */}
            <div className="w-full">
                <VideoGridSection items={firstBatch} showViewAll={false} />
            </div>

            {/* UPGRADED IMAGE PROMO BANNER */}
            <div className="w-full h-[200px] md:h-[240px] rounded-3xl overflow-hidden relative shadow-md group transition-all hover:shadow-xl border border-gray-100">
                {/* Background Image Banner Asset */}
                <img
                    src="https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?auto=format&fit=crop&q=80&w=1600"
                    alt="Pet Promo Deal"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
            </div>

            {/* BATCH 2: REMAINING VIDEOS */}
            {secondBatch.length > 0 && (
                <div className="w-full space-y-4">
                    <div className="border-l-4 border-amber-500 pl-3">
                        <h2 className="text-lg font-bold text-logoHeading tracking-tight">Keep Exploring</h2>
                        <p className="text-xs text-gray-400 font-medium">More pet recommendations based on your feed</p>
                    </div>
                    <VideoGridSection items={secondBatch} showViewAll={false} />
                </div>
            )}

        </div>
    );
};

export default CustomerVideoScreen;